import React, { useState, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import styles from "assets/jss/material-kit-react/views/loginPage.js";
import image from "assets/img/background.jpg";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import AlertDialog from "../components/AlertDialog";
import CountrySelect from "../components/CountrySelect";
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import {
  Paper,
  FormControl,
  Select,
  MenuItem,
  Tabs,
  Tab,
} from "@material-ui/core";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import PhoneOutlinedIcon from "@material-ui/icons/PhoneOutlined";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import DriveEtaOutlinedIcon from "@material-ui/icons/DriveEtaOutlined";
import AccountBalanceOutlinedIcon from "@material-ui/icons/AccountBalanceOutlined";
import InsertDriveFileOutlinedIcon from "@material-ui/icons/InsertDriveFileOutlined";
import AssignmentIndOutlinedIcon from '@material-ui/icons/AssignmentIndOutlined';
import { language, default_country_code, features } from "config";
import { FirebaseContext } from "common";

const useStyles = makeStyles(styles);

export default function LoginPage(props) {
  const { api } = useContext(FirebaseContext);
  const {
    clearLoginError,
    emailSignUp,
    checkUserExists,
    validateReferer,
  } = api;

  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [state, setState] = React.useState({
    usertype: "rider",
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    password: "",
    nationalID: "",
    referralId: "",
    vehicleNumber: "",
    vehicleMake: "",
    vehicleModel: "",
    other_info: "",
    carType: props.cars && props.cars.length > 0 ? props.cars[0].value : "",
    bankAccount: "",
    bankCode: "",
    bankName: "",
    identityFrontImage: null,
    licenseImage: null,
    logBookImage: null,
    driversInsurance: null,
    certOfConduct: null,
    vehiclePhoto: null,
    driverFrontImage: null,
    driverBackImage: null
  });

  const cartypes = useSelector((state) => state.cartypes.cars);
  const [carType, setCarType] = useState(language.select_car);
  const [selectedCarDetails, setSelectedCarDetails] = useState(null);

  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const [countryCode, setCountryCode] = useState(default_country_code);
  const [mobileWithoutCountry, setMobileWithoutCountry] = useState("");

  const classes = useStyles();
  const { ...rest } = props;

  const onInputChange = (event) => {
    setState({ ...state, [event.target.id]: event.target.value });
  };

  // const [licenseImageAsFile, setLicenseImageAsFile] = useState(null);
  // const [logBookImageAsFile, setLogBookImageAsFile] = useState(null);
  // const [insuranceImageAsFile, setInsuranceImageAsFile] = useState(null);
  // const [certificateImageAsFile, setCertificateImageAsFile] = useState(null);
  // const [vehicleImageAsFile, setVehicleImageAsFile] = useState(null);
  // const [othersImageAsFile, setOthersImageAsFile] = useState(null);

  const handleCustomerIdImageAsFile = (e) => {
    const image = e.target.files[0];
    setState({ ...state, identityFrontImage: image });
  };
  const handleLicenseImageAsFile = (e) => {
    const image = e.target.files[0];
    setState({ ...state, licenseImage: image });
  };
  const handleLogbookImageAsFile = (e) => {
    const image = e.target.files[0];
    // setLogBookImageAsFile(imageFile => (image));
    setState({ ...state, logBookImage: image });
  };
  const handleInsuranceImageAsFile = (e) => {
    const image = e.target.files[0];
    // setInsuranceImageAsFile(imageFile => (image));
    setState({ ...state, driversInsurance: image });
  };
  const handleCertificateImageAsFile = (e) => {
    const image = e.target.files[0];
    // setCertificateImageAsFile(imageFile => (image));
    setState({ ...state, certOfConduct: image });
  };
  const handleVehicleImageAsFile = (e) => {
    const image = e.target.files[0];
    // setVehicleImageAsFile(imageFile => (image));
    setState({ ...state, vehiclePhoto: image });
  };
  const handleIDFrontImageAsFile = (e) => {
    const image = e.target.files[0];
    // setOthersImageAsFile(imageFile => (image));
    setState({ ...state, driverFrontImage: image });
  };
  const handleIDBackImageAsFile = (e) => {
    const image = e.target.files[0];
    // setOthersImageAsFile(imageFile => (image));
    setState({ ...state, driverBackImage: image });
  };
 


  const validateMobile = () => {
    let mobileValid = true;
    if (mobileWithoutCountry.length < 6) {
      mobileValid = false;
      setCommonAlert({ open: true, msg: language.mobile_no_blank_error });
    }
    if (
      mobileWithoutCountry.includes("+") ||
      mobileWithoutCountry.includes(" ") ||
      mobileWithoutCountry.includes("-")
    ) {
      mobileValid = false;
      setCommonAlert({ open: true, msg: language.mobile_no_blank_error });
    }
    return mobileValid;
  };

  const handleCarSelect = (event) => {
    setCarType(event.target.value);
    let carDetails = null;
    for (let i = 0; i < cartypes.length; i++) {
      if (cartypes[i].name === event.target.value) {
        carDetails = cartypes[i];
      }
    }
    setSelectedCarDetails(carDetails);
  };

  const validatePassword = (complexity) => {
    let passwordValid = true;
    const regx1 = /^([a-zA-Z0-9@*#]{8,15})$/;
    const regx2 = /(?=^.{6,10}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*()_+}{&quot;:;'?/&gt;.&lt;,])(?!.*\s).*$/;
    if (complexity === "any") {
      passwordValid = state.password.length >= 1;
      if (!passwordValid) {
        setCommonAlert({ open: true, msg: language.password_blank_messege });
      }
    } else if (complexity === "alphanumeric") {
      passwordValid = regx1.test(state.password);
      if (!passwordValid) {
        setCommonAlert({
          open: true,
          msg: language.password_alphaNumeric_check,
        });
      }
    } else if (complexity === "complex") {
      passwordValid = regx2.test(state.password);
      if (!passwordValid) {
        setCommonAlert({ open: true, msg: language.password_complexity_check });
      }
    }
    return passwordValid;
  };

  const handleRegister = () => {
    console.log(state);
    //eslint-disable-next-line
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (state.firstName.length > 0 && state.lastName.length > 0) {
      if (re.test(state.email)) {
        if (validatePassword("alphanumeric")) {
          if (validateMobile()) {
            checkUserExists(state).then((res) => {
              if (res.users && res.users.length > 0) {
                setCommonAlert({ open: true, msg: language.user_exists });
              } else if (res.error) {
                setCommonAlert({
                  open: true,
                  msg: language.email_or_mobile_issue,
                });
              } else {
                if (state.referralId && state.referralId.length > 0) {
                  validateReferer(state.referralId)
                    .then((referralInfo) => {
                      if (referralInfo.uid) {
                        emailSignUp({
                          ...state,
                          signupViaReferral: referralInfo.uid,
                        }).then((res) => {
                          if (res.uid) {
                            setCommonAlert({
                              open: true,
                              msg: language.account_create_successfully,
                            });
                            setTimeout(() => {
                              props.history.push("/login");
                            }, 3000);
                          } else {
                            setCommonAlert({
                              open: true,
                              msg: language.reg_error,
                            });
                          }
                        });
                      } else {
                        setCommonAlert({
                          open: true,
                          msg: language.referer_not_found,
                        });
                      }
                    })
                    .catch((error) => {
                      setCommonAlert({
                        open: true,
                        msg: language.referer_not_found,
                      });
                    });
                } else {
                  if (state.usertype == 'driver' && state.licenseImage == null &&
                    state.vehiclePhoto == null &&
                    state.certOfConduct == null &&
                    state.driversInsurance == null &&
                    state.driverFrontImage == null &&
                    state.driverFrontImage == null &&
                    state.logBookImage == null) {
                    setCommonAlert({
                      open: true,
                      msg: language.documents_upload,
                    });
                  }
                  if( state.usertype == 'rider' && state.identityFrontImage == null){
                    setCommonAlert({
                      open: true,
                      msg: language.documents_upload,
                    });
                  }
                  emailSignUp(state).then((res) => {
                    if (res.uid) {
                      setCommonAlert({
                        open: true,
                        msg: language.account_create_successfully,
                      });
                      setTimeout(() => {
                        props.history.push("/login");
                      }, 3000);
                    } else {
                      setCommonAlert({ open: true, msg: language.reg_error });
                    }
                  });
                }
              }
            });
          } else {
            setCommonAlert({ open: true, msg: language.mobile_no_blank_error });
          }
        }
      } else {
        setCommonAlert({ open: true, msg: language.proper_email });
      }
    } else {
      setCommonAlert({ open: true, msg: language.proper_input_name });
    }
  };

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
    if (auth.error.flag) {
      dispatch(clearLoginError());
    }
  };

  const handleBack = (e) => {
    e.preventDefault();
    props.history.push("/login");
  };

  return (
    <div>
      <Header
        absolute
        color="transparent"
        rightLinks={<HeaderLinks />}
        {...rest}
      />
      <div
        className={classes.pageHeader}
        style={{
          backgroundImage: "url(" + image + ")",
          backgroundSize: "cover",
          backgroundPosition: "top center",
        }}
      >
        <div id="sign-in-button" />
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={4}>
              <Card style={{ height: "100%" }}>
                <form className={classes.form}>
                  <Paper
                    square
                    className={classes.root}
                    style={{
                      paddingTop: 20,
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                    }}
                  >
                    <Tabs
                      value={0}
                      variant="fullWidth"
                      indicatorColor="primary"
                      textColor="inherit"
                      aria-label="switch login type"
                    >
                      <Tab
                        disabled={true}
                        icon={<PersonOutlineOutlinedIcon />}
                        label={language.personal_details}
                        aria-label="email"
                      />
                    </Tabs>
                  </Paper>

                  <CardBody>
                    <CustomInput
                      labelText={language.firstname}
                      id="firstName"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "text",
                        required: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <PersonOutlineOutlinedIcon
                              className={classes.inputIconsColor}
                            />
                          </InputAdornment>
                        ),
                      }}
                      onChange={onInputChange}
                      value={state.firstName}
                    />
                    <CustomInput // LAST NAME
                      labelText={language.lastname}
                      id="lastName"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "text",
                        required: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <PersonOutlineOutlinedIcon
                              className={classes.inputIconsColor}
                            />
                          </InputAdornment>
                        ),
                      }}
                      onChange={onInputChange}
                      value={state.lastName}
                    />
                    <CustomInput
                      labelText={language.email}
                      id="email"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "email",
                        required: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <EmailOutlinedIcon
                              className={classes.inputIconsColor}
                            />
                          </InputAdornment>
                        ),
                      }}
                      onChange={onInputChange}
                      value={state.email}
                    />
                    <CustomInput
                      labelText={language.password}
                      id="password"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "password",
                        required: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <LockOutlinedIcon
                              className={classes.inputIconsColor}
                            />
                          </InputAdornment>
                        ),
                        autoComplete: "off",
                      }}
                      onChange={onInputChange}
                      value={state.password}
                    />
                    {features.AllowCountrySelection ? ( // COUNTRY
                      <CountrySelect
                        value={countryCode}
                        onChange={(object, value) => {
                          setCountryCode(value);
                          let formattedNum = mobileWithoutCountry.replace(
                            / /g,
                            ""
                          );
                          formattedNum =
                            "+" + value.phone + formattedNum.replace(/-/g, "");
                          setState({ ...state, mobile: formattedNum });
                        }}
                        style={{ paddingTop: 20 }}
                        disabled={state.verificationId ? true : false}
                      />
                    ) : null}
                    <CustomInput
                      labelText={language.phone}
                      id="mobile"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        required: true,
                        disabled: state.verificationId ? true : false,
                        endAdornment: (
                          <InputAdornment position="end">
                            <PhoneOutlinedIcon
                              className={classes.inputIconsColor}
                            />
                          </InputAdornment>
                        ),
                      }}
                      onChange={(event) => {
                        setMobileWithoutCountry(event.target.value);
                        let formattedNum = event.target.value.replace(/ /g, "");
                        formattedNum =
                          "+" +
                          countryCode.phone +
                          formattedNum.replace(/-/g, "");
                        setState({ ...state, mobile: formattedNum });
                      }}
                      value={mobileWithoutCountry}
                    />
                    <CustomInput
                      labelText={language.national_id_number}
                      id="nationalID"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "text",
                        required: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <AssignmentIndOutlinedIcon
                              className={classes.inputIconsColor}
                            />
                          </InputAdornment>
                        ),
                      }}
                      onChange={onInputChange}
                      value={state.nationalID}
                    />
                     {state.usertype !== 'driver' ?
                    <div>
                    <label style={{ color: '#000', marginTop: 5 }}>{language.national_id}</label>
                      <input
                        name="file-upload"
                        type="file"
                        onChange={handleCustomerIdImageAsFile}
                        style={{ marginTop: 5, border: '1px solid #d2d2d2', padding: 10, borderRadius: 5 }}
                      />
                      </div>
                      :null}
                    <CustomInput // LAST NAME
                      labelText={language.referralId}
                      id="referralId"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "text",
                        required: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <EmailOutlinedIcon
                              className={classes.inputIconsColor}
                            />
                          </InputAdornment>
                        ),
                      }}
                      onChange={onInputChange}
                      value={state.referralId}
                    />
                    {true ?
                      <div style={{ padding: 20 }}>
                        <label for="register-option" style={{ margin: 5 }}>
                          {language.register_as_driver}
                        </label>
                        <input
                          id="usertype"
                          type="radio"
                          value="rider"
                          defaultChecked
                          name="register-option"
                          onChange={onInputChange}
                        />{" "}
                      No
                      <input
                          id="usertype"
                          type="radio"
                          value="driver"
                          name="register-option"
                          onChange={onInputChange}
                        />{" "}
                      Yes
                    </div>
                      : null}
                  </CardBody>
                  {state.usertype !== 'driver' ?
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                      <p style={{ marginTop: 0, textAlign: 'center', fontSize: 14 }}>By signing up, you accept our <a href='https://saharaexpress.app/tandc' >Terms of Service</a><p style={{display: 'inline'}}> and </p><a href='https://saharaexpress.app/privacy-policy'>Privacy Policy</a></p>
                    </div>
                    : null}
                  {state.usertype !== 'driver' ?
                    <CardFooter className={classes.cardFooter}>
                      <Button
                        className={classes.normalButton}
                        simple
                        color="primary"
                        size="lg"
                        onClick={handleRegister}
                      >
                        {language.register}
                      </Button>
                      <Button
                        className={classes.normalButton}
                        simple
                        color="primary"
                        size="lg"
                        onClick={handleBack}
                      >
                        {language.back}
                      </Button>
                    </CardFooter>
                    : null}
                </form>
              </Card>
            </GridItem>
            {state.usertype === "driver" ? (
              <GridItem xs={12} sm={12} md={4}>
                <Card style={{ height: "100%" }}>
                  <form className={classes.form}>
                    <Paper
                      square
                      className={classes.root}
                      style={{
                        paddingTop: 20,
                        borderTopLeftRadius: 10,
                        borderTopRightRadius: 10,
                      }}
                    >
                      <Tabs
                        value={0}
                        variant="fullWidth"
                        indicatorColor="primary"
                        textColor="inherit"
                        aria-label="switch login type"
                      >
                        <Tab
                          disabled={true}
                          icon={<DriveEtaOutlinedIcon />}
                          label={language.vehicle_details}
                          aria-label="email"
                        />
                      </Tabs>
                    </Paper>

                    <CardBody>
                      <FormControl style={{ width: "100%" }}>
                        <Select style={{ marginTop: 20 }}
                          id="car-type-native"
                          value={carType}
                          onChange={handleCarSelect}
                          className={
                            carType === language.select_car
                              ? classes.inputdimmed
                              : classes.input
                          }
                        >
                          <MenuItem
                            value={language.select_car}
                            key={language.select_car}
                          >
                            {language.select_car}
                          </MenuItem>
                          {cartypes.map((car) => (
                            <MenuItem key={car.name} value={car.name}>
                              <img
                                src={car.image}
                                style={{ width: 20 }}
                                className={classes.carphoto}
                                alt="car types"
                              />
                              {car.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <CustomInput // LAST NAME
                        labelText={language.vehicle_model_name}
                        id="vehicleMake"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          required: true,
                          endAdornment: (
                            <InputAdornment position="end">
                              <DriveEtaOutlinedIcon
                                className={classes.inputIconsColor}
                              />
                            </InputAdornment>
                          ),
                        }}
                        onChange={onInputChange}
                        value={state.vehicleMake}
                      />
                      <CustomInput
                        labelText={language.vehicle_model_no}
                        id="vehicleModel"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          required: true,
                          endAdornment: (
                            <InputAdornment position="end">
                              <DriveEtaOutlinedIcon
                                className={classes.inputIconsColor}
                              />
                            </InputAdornment>
                          ),
                        }}
                        onChange={onInputChange}
                        value={state.vehicleModel}
                      />
                      <CustomInput
                        labelText={language.vehicle_reg_no}
                        id="vehicleNumber"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          required: true,
                          endAdornment: (
                            <InputAdornment position="end">
                              <DriveEtaOutlinedIcon
                                className={classes.inputIconsColor}
                              />
                            </InputAdornment>
                          ),
                          autoComplete: "off",
                        }}
                        onChange={onInputChange}
                        value={state.vehicleNumber}
                      />
                      <CustomInput // LAST NAME
                        labelText={language.other_info}
                        id="other_info"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          required: true,
                          endAdornment: (
                            <InputAdornment position="end">
                              <DriveEtaOutlinedIcon
                                className={classes.inputIconsColor}
                              />
                            </InputAdornment>
                          ),
                        }}
                        onChange={onInputChange}
                        value={state.other_info}
                      />
                      <CustomInput // LAST NAME
                        labelText={language.bankName}
                        id="bankName"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          required: true,
                          endAdornment: (
                            <InputAdornment position="end">
                              <AccountBalanceOutlinedIcon
                                className={classes.inputIconsColor}
                              />
                            </InputAdornment>
                          ),
                        }}
                        onChange={onInputChange}
                        value={state.bankName}
                      />
                      <CustomInput // LAST NAME
                        labelText={language.bankCode}
                        id="bankCode"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          required: true,
                          endAdornment: (
                            <InputAdornment position="end">
                              <AccountBalanceOutlinedIcon
                                className={classes.inputIconsColor}
                              />
                            </InputAdornment>
                          ),
                        }}
                        onChange={onInputChange}
                        value={state.bankCode}
                      />
                      <CustomInput // LAST NAME
                        labelText={language.bankAccount}
                        id="bankAccount"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          required: true,
                          endAdornment: (
                            <InputAdornment position="end">
                              <AccountBalanceOutlinedIcon
                                className={classes.inputIconsColor}
                              />
                            </InputAdornment>
                          ),
                        }}
                        onChange={onInputChange}
                        value={state.bankAccount}
                      />
                    </CardBody>
                  </form>
                </Card>
              </GridItem>
            ) : null}
            {state.usertype === "driver" ? (
              <GridItem xs={12} sm={12} md={4}>
                <Card style={{ height: "100%" }}>
                  <form className={classes.form}>
                    <Paper
                      square
                      className={classes.root}
                      style={{
                        paddingTop: 20,
                        borderTopLeftRadius: 10,
                        borderTopRightRadius: 10,
                      }}
                    >
                      <Tabs
                        value={0}
                        variant="fullWidth"
                        indicatorColor="primary"
                        textColor="inherit"
                        aria-label="switch login type"
                      >
                        <Tab
                          disabled={true}
                          icon={<InsertDriveFileOutlinedIcon />}
                          label={language.upload_documents}
                          aria-label="email"
                        />
                      </Tabs>
                    </Paper>

                    <CardBody
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <label style={{ color: '#000', marginTop: 5 }}>{language.driver_license}</label>
                      <input
                        name="file-upload"
                        type="file"
                        onChange={handleLicenseImageAsFile}
                        style={{ marginTop: 5, border: '1px solid #d2d2d2', padding: 10, borderRadius: 5 }}
                      />
                      <label style={{ color: '#000', marginTop: 5 }}>{language.vehicle_registration}</label>
                      <input
                        name="file-upload"
                        type="file"
                        onChange={handleLogbookImageAsFile}
                        style={{ marginTop: 5, border: '1px solid #d2d2d2', padding: 10, borderRadius: 5 }}
                      />
                      <label style={{ color: '#000', marginTop: 5 }}>{language.vehicle_insurance}</label>
                      <input
                        name="file-upload"
                        type="file"
                        onChange={handleInsuranceImageAsFile}
                        style={{ marginTop: 5, border: '1px solid #d2d2d2', padding: 10, borderRadius: 5 }}
                      />
                      <label style={{ color: '#000', marginTop: 5 }}>
                        {language.certificate_of_good_conduct}
                      </label>
                      <input
                        name="file-upload"
                        type="file"
                        onChange={handleCertificateImageAsFile}
                        style={{ marginTop: 5, border: '1px solid #d2d2d2', padding: 10, borderRadius: 5 }}
                      />
                      <label style={{ color: '#000', marginTop: 5 }}>{language.photo_of_vehicle}</label>
                      <input
                        name="file-upload"
                        type="file"
                        onChange={handleVehicleImageAsFile}
                        style={{ marginTop: 5, border: '1px solid #d2d2d2', padding: 10, borderRadius: 5 }}
                      />
                      <label style={{ color: '#000', marginTop: 5 }}>{language.id_front}</label>
                      <input
                        name="file-upload"
                        type="file"
                        onChange={handleIDFrontImageAsFile}
                        style={{ marginTop: 5, border: '1px solid #d2d2d2', padding: 10, borderRadius: 5 }}
                      />
                      <label style={{ color: '#000', marginTop: 5 }}>{language.id_back}</label>
                      <input
                        name="file-upload"
                        type="file"
                        onChange={handleIDBackImageAsFile}
                        style={{ marginTop: 5, border: '1px solid #d2d2d2', padding: 10, borderRadius: 5 }}
                      />
                      {state.usertype == 'driver' ?
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                      <p style={{ marginTop: 0, textAlign: 'center', fontSize: 14 }}>By signing up, you accept our <a href='https://saharaexpress.app/tandc' >Terms of Service</a><p style={{display: 'inline'}}> and </p><a href='https://saharaexpress.app/privacy-policy'>Privacy Policy</a></p>
                    </div>
                    : null}
                    </CardBody>
                    <CardFooter className={classes.cardFooter}>
                      <Button
                        className={classes.normalButton}
                        simple
                        color="primary"
                        size="lg"
                        onClick={handleRegister}
                      >
                        {language.register}
                      </Button>
                      <Button
                        className={classes.normalButton}
                        simple
                        color="primary"
                        size="lg"
                        onClick={handleBack}
                      >
                        {language.back}
                      </Button>
                    </CardFooter>
                  </form>
                </Card>
              </GridItem>
            ) : null}
          </GridContainer>
        </div>
        <Footer whiteFont />
        <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
          {commonAlert.msg}
        </AlertDialog>
      </div>
    </div>
  );
}


